export const HEADER_TEST_IDS = {
  root: 'header',
  merchantName: 'name',
  merchantLogo: 'logo',
  defaultLogo: 'default-logo',
};
